import HomeButton from './shared/HomeButton';
import QuestionFilters from './questions/QuestionFilters';
import QuestionItem from './questions/QuestionItem';

export default function QuestionsSidebar({
  searchTerm,
  setSearchTerm,
  selectedProduct,
  setSelectedProduct,
  selectedCategory,
  setSelectedCategory,
  filteredQuestions,
  selectedQuestion,
  handleQuestionClick,
  handleAnswerClick,
  products = [],
  categories = []
}) {
  return (
    <div className="h-full flex flex-col relative">
      {/* Header with Title and Home Button */}
      <div className="h-16 border-b border-gray-700 px-4 flex items-center space-x-3">
        <HomeButton />
        <h1 className="text-xl font-bold text-white">Questions</h1>
      </div>

      {/* Filters */}
      <div className="p-4 border-b border-gray-700 flex-shrink-0">
        <QuestionFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          products={products}
          categories={categories}
        />
      </div>

      {/* Questions List */}
      <div className="flex-1 overflow-y-auto">
        {/* Question Count Header */}
        <div className="px-4 py-2 border-b border-gray-700/50">
          <p className="text-xs text-gray-500 font-semibold">
            {filteredQuestions.length} {filteredQuestions.length === 1 ? 'Question' : 'Questions'}
          </p>
        </div>

        {/* Questions */}
        <div className="p-4 space-y-2">
          {filteredQuestions.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <p>No questions found</p>
            </div>
          ) : (
            filteredQuestions.map((question) => (
              <QuestionItem
                key={question.id}
                question={question}
                isSelected={selectedQuestion?.id === question.id}
                onClick={() => handleQuestionClick(question)}
                onAnswerClick={handleAnswerClick}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
